export const SET_USER = 'currentUser__SET_USER';
export const UPDATE_USER = 'currentUser__UPDATE_USER';
export const CLEAR_USER = 'currentUser__CLEAR_USER';

export const SET_ITEM = 'misc__SET_ITEM';
export const SET_SITE_VISITORS = 'misc__SET_SITE_VISITORS';

export const SAVE_ANSWERS = 'savedExamAnswers__SAVE_ANSWERS';
export const CLEAR_ANSWERS = 'savedExamAnswers__CLEAR_ANSWERS';
